import axios from "axios";

const instance = axios.create({
  baseURL: "https://handburger-e9d1f.firebaseio.com/",
});

export default instance;



// WEBPACK FOOTER //
// ./src/axios-orders.js